// extracted by mini-css-extract-plugin
export default {"item":"Waiting_item__pfOZ3","item-wp":"Waiting_item-wp__u-xwU"};